import { useState } from 'react';
import Editor from './Editor';
import ButtonLoader from './ButtonLoader';

const PotentialHireEmailForm = ({ selectedCount, onSubmit, isLoading, onCloseClicked }) => {
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ subject, content });
  };

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[700px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Send Email — {selectedCount} {selectedCount === 1 ? 'recipient' : 'recipients'}</p>
        <p onClick={onCloseClicked} className="font-bold cursor-pointer text-2xl">X</p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Subject *</label>
          <input
            className="border border-ase-blue rounded-md px-3 py-2 text-sm w-full outline-none focus:ring-1 focus:ring-ase-blue"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            required
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Content *</label>
          <Editor value={content} setCurrentValue={setContent} />
        </div>

        <button
          type="submit"
          disabled={isLoading || !content}
          className="bg-ase-blue text-white font-semibold py-2 rounded-md text-sm disabled:opacity-60 flex items-center justify-center"
        >
          {isLoading ? <ButtonLoader /> : `Send to ${selectedCount} ${selectedCount === 1 ? 'person' : 'people'}`}
        </button>
      </form>
    </div>
  );
};

export default PotentialHireEmailForm;
